import { ChangeDetectionStrategy, Component, TemplateRef, viewChild, Signal } from '@angular/core';

@Component({
  selector: 'td-wb-simplified-list-item',
  templateUrl: './simplified-list-item.component.html',
  styleUrls: ['./simplified-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimplifiedListItemComponent {
  readonly templateRef: Signal<TemplateRef<unknown> | undefined> = viewChild(TemplateRef, { read: TemplateRef });
}
